"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MoreHor_exports = {};
__export(MoreHor_exports, {
  default: () => MoreHor_default
});
module.exports = __toCommonJS(MoreHor_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.5 8.58984C5.04427 8.58984 4.65365 8.7526 4.32812 9.07812C4.0026 9.40365 3.83984 9.79427 3.83984 10.25C3.83984 10.7057 4.0026 11.0964 4.32812 11.4219C4.65365 11.7474 5.04427 11.9102 5.5 11.9102C5.95573 11.9102 6.34635 11.7474 6.67188 11.4219C6.9974 11.0964 7.16016 10.7057 7.16016 10.25C7.16016 9.79427 6.9974 9.40365 6.67188 9.07812C6.34635 8.7526 5.95573 8.58984 5.5 8.58984ZM15.5 8.58984C15.0443 8.58984 14.6536 8.7526 14.3281 9.07812C14.0026 9.40365 13.8398 9.79427 13.8398 10.25C13.8398 10.7057 14.0026 11.0964 14.3281 11.4219C14.6536 11.7474 15.0443 11.9102 15.5 11.9102C15.9557 11.9102 16.3464 11.7474 16.6719 11.4219C16.9974 11.0964 17.1602 10.7057 17.1602 10.25C17.1602 9.79427 16.9974 9.40365 16.6719 9.07812C16.3464 8.7526 15.9557 8.58984 15.5 8.58984ZM10.5 8.58984C10.0443 8.58984 9.65365 8.7526 9.32812 9.07812C9.0026 9.40365 8.83984 9.79427 8.83984 10.25C8.83984 10.7057 9.0026 11.0964 9.32812 11.4219C9.65365 11.7474 10.0443 11.9102 10.5 11.9102C10.9557 11.9102 11.3464 11.7474 11.6719 11.4219C11.9974 11.0964 12.1602 10.7057 12.1602 10.25C12.1602 9.79427 11.9974 9.40365 11.6719 9.07812C11.3464 8.7526 10.9557 8.58984 10.5 8.58984Z",
      fill: "currentColor"
    }
  )
);
const SvgMoreHor = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var MoreHor_default = SvgMoreHor;
